'use strict';

var bufferedQueue = require('@getgo/buffered-queue');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var memoizeStorageAvailability = function memoizeStorageAvailability(checkStorageAvailability) {
  var isStorageAvailable;
  var memoizedStorage;
  return function (storage) {
    if (typeof isStorageAvailable !== 'undefined' && memoizedStorage === storage) {
      return isStorageAvailable;
    }

    memoizedStorage = storage;
    isStorageAvailable = checkStorageAvailability(storage);
    return isStorageAvailable;
  };
};

var checkStorageAvailable = function checkStorageAvailable(storage) {
  if (!storage) {
    return false;
  }

  try {
    var x = '__storage_test__';
    storage.setItem(x, x);
    var y = storage.getItem(x);
    storage.removeItem(x);
    return x === y;
  } catch (e) {
    return false;
  }
};
var memoizedCheckStorageAvailable = memoizeStorageAvailability(checkStorageAvailable);

var executeIfAvailable = function executeIfAvailable(operation, fallback) {
  return function (storage) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return memoizedCheckStorageAvailable(storage) ? operation.apply(void 0, [storage].concat(args)) : fallback();
  };
};

var getFromStorageByKeys = executeIfAvailable(function (storage, keys) {
  return keys.reduce(function (acc, key) {
    return _objectSpread2({}, acc, _defineProperty({}, key, getStorageItemByKey(storage, key)));
  }, {});
}, function () {
  return {};
});
var getStorageKeysByPrefix = executeIfAvailable(function (storage, keyprefix) {
  var arr = _toConsumableArray(new Array(storage.length));

  return arr.map(function (_, i) {
    return storage.key(i);
  }).filter(function (item) {
    return item.indexOf(keyprefix) === 0;
  });
}, function () {
  return [];
});
var setItemToStorage = executeIfAvailable(function (storage, key, data) {
  storage.setItem(key, JSON.stringify(data));
}, function () {});
var removeStorageItems = executeIfAvailable(function (storage, keys) {
  keys.forEach(function (key) {
    return storage.removeItem(key);
  });
}, function () {});
var getStorageItemByKey = executeIfAvailable(function (storage, key) {
  return storage.getItem(key);
}, function () {});

var addEventListener = function addEventListener(window) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return window && window.addEventListener && window.addEventListener.apply(window, args);
};

var DEFAULT_TIME_ALIVE_MS = 7200000; // 2 hours

var isCurrentDateLessThanExpireDate = function isCurrentDateLessThanExpireDate(storageDate, storageDataAvailableTime) {
  return storageDate + storageDataAvailableTime > Date.now();
};
var removeStoredEvents = function removeStoredEvents(storage, keyprefix) {
  var keys = getStorageKeysByPrefix(storage, keyprefix);
  removeStorageItems(storage, keys);
};
var saveUnreportedEventsToStorage = function saveUnreportedEventsToStorage(storage, events, keyprefix, options) {
  events.length && setItemToStorage(storage, keyprefix + options.id_run, {
    data: events,
    storageDataAvailableTime: options.storageDataAvailableTime || DEFAULT_TIME_ALIVE_MS,
    storageDate: Date.now()
  });
};
var getUnreportedEventsFormStorage = function getUnreportedEventsFormStorage(storage, keyprefix) {
  var storedKeys = getStorageKeysByPrefix(storage, keyprefix);
  var allStoredEvents = getFromStorageByKeys(storage, storedKeys);
  return Object.values(allStoredEvents).filter(Boolean).reduce(function (acc, value) {
    var _JSON$parse = JSON.parse(value),
        data = _JSON$parse.data,
        storageDate = _JSON$parse.storageDate,
        storageDataAvailableTime = _JSON$parse.storageDataAvailableTime;

    return isCurrentDateLessThanExpireDate(storageDate, storageDataAvailableTime) ? [].concat(_toConsumableArray(acc), _toConsumableArray(data)) : acc;
  }, []);
};
var handleUnreportedEventsBeforeUnload = function handleUnreportedEventsBeforeUnload(window, buffer, keyprefix, options) {
  addEventListener(window, 'beforeunload', memoizedCheckStorageAvailable(window.localStorage) ? function () {
    return saveUnreportedEventsToStorage(window.localStorage, buffer.clear(), keyprefix, options);
  } : function () {
    return buffer.flush();
  });
};
var addUnreportedEventsFromStorageToBuffer = function addUnreportedEventsFromStorageToBuffer(storage, buffer, keyprefix) {
  buffer.add.apply(buffer, _toConsumableArray(getUnreportedEventsFormStorage(storage, keyprefix)));
};
var sendEventsOnBufferFlush = function sendEventsOnBufferFlush(buffer, sender) {
  buffer.on('flush', function (content) {
    if (Array.isArray(content.data) && content.data.length) {
      return sender(content.data);
    }
  });
};
var createBuffer = function createBuffer(size) {
  return new bufferedQueue.BufferedQueue({
    maxSize: size || undefined
  });
};

var send = function send(url, logger, options) {
  return function (events) {
    var payload = {
      events: events
    };

    if (options.ev_schema_name) {
      Object.assign(payload, {
        ev_schema_name: options.ev_schema_name,
        ev_schema_ver: options.ev_schema_ver,
        ev_source: options.ev_source,
        id_run: options.id_run
      });
    }

    return fetch(url, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'PUT',
      body: JSON.stringify(payload)
    })["catch"](function (error) {
      (logger || console).error(error);
    });
  };
};
/**
 * @private
 * @class FetchBufferedQueueFactory
 *
 * @param {window} window
 */


function FetchBufferedQueueFactory(window) {
  /**
   * @memberOf FetchBufferedQueueFactory#
   *
   * @param {string} url
   * @param {TelemetryOptions} options
   *
   * @param {Logger} [logger]
   * @returns {TelemetryTransport}
   */
  function createTransport(url, options, logger) {
    var keyprefix = 'telemetry.' + url.replace(/^http(s?):\/\//, '');
    var buffer = createBuffer(parseInt(options.queuesize, 10));
    addUnreportedEventsFromStorageToBuffer(window.localStorage, buffer, keyprefix);
    removeStoredEvents(window.localStorage, keyprefix);
    sendEventsOnBufferFlush(buffer, send(url, logger, options));
    handleUnreportedEventsBeforeUnload(window, buffer, keyprefix, options);
    return {
      add: buffer.add,
      flush: buffer.flush
    };
  }

  this.createTransport = createTransport;
}

var fetchBufferedQueue = new FetchBufferedQueueFactory(window || global);

module.exports = fetchBufferedQueue;
